import React, { useState } from 'react';
import { Modal, Card, Row, Col, Button, Typography, Input, Space, message, Form } from 'antd';
import ApiService from '../Components/apiService';
import { BASE_URL } from '../Components/Constant';

const { Text } = Typography;

const CloneOrgModal = ({ visible, onClose, organizationId, onCloneSuccess }) => {
  const [step, setStep] = useState(1);
  const [cloneType, setCloneType] = useState('Developer Sandbox');
  const [orgName, setOrgName] = useState('');
  const [environmentType, setEnvironmentType] = useState('');
  const [loading, setLoading] = useState(false);
  const [cloneForm] = Form.useForm();

  const handleNext = () => setStep(2);

  const handleCancel = () => {
    setStep(1);
    setCloneType('Developer Sandbox');
    setOrgName('');
    setEnvironmentType('');
    cloneForm.resetFields();
    onClose();
  };

  const handleSave = async () => {
    if (!orgName.trim() || !environmentType.trim()) {
      message.warning('Please enter both organization name and environment type.');
      return;
    }

    console.log('Cloning org with name:', orgName, 'environment:', environmentType, 'from org ID:', organizationId);

    try {
      setLoading(true);

      const payload = {
        org_info: {
          target_org_name: orgName,          // dynamic org name entered by user
          source_org_id: organizationId,     // maps to source_org_id
          environment_type: environmentType, // dynamic environment type (free text)
          clone_level: 'Metadata', 
        },
      };

      console.log('Clone payload:', payload);

      const apiService = new ApiService(
        `${BASE_URL}/super_admin/org_clone`,
        { 'Content-Type': 'application/json' },
        'POST',
        payload
      );

      await apiService.makeCall();
      message.success(`Organization "${orgName}" clone initiated successfully!`);

      handleCancel();
      if (onCloneSuccess) onCloneSuccess();
    } catch (err) {
      console.error('Clone error:', err);
      message.error('Failed to clone organization');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={visible}
      title="New Sandbox"
      onCancel={handleCancel}
      footer={null}
      width={600}
    >
      {step === 1 && (
        <Row gutter={16} justify="center">
          <Col xs={24} md={10}>
            <Card
              hoverable
              style={{
                borderColor: cloneType === 'Developer Sandbox' ? '#1890ff' : undefined,
                textAlign: 'center'
              }}
              onClick={() => setCloneType('Developer Sandbox')}
            >
              <Text strong>Developer Sandbox</Text>
            </Card>
          </Col>

          <Col xs={24} md={10}>
            <Card
              hoverable
              style={{
                borderColor: cloneType === 'Full Sandbox' ? '#1890ff' : undefined,
                textAlign: 'center'
              }}
              onClick={() => setCloneType('Full Sandbox')}
            >
              <Text strong>Full Sandbox</Text>
            </Card>
          </Col>

          <Col span={24} style={{ marginTop: 24, textAlign: 'right' }}>
            <Space>
              <Button onClick={handleCancel}>Cancel</Button>
              <Button type="primary" onClick={handleNext}>
                Next
              </Button>
            </Space>
          </Col>
        </Row>
      )}

      {step === 2 && (
        <Form form={cloneForm} layout="vertical">
          <Row justify="center">
            <Col xs={24} md={18}>
              <Form.Item label="Sandbox Name" required>
                <Input
                  placeholder="Enter new organization name"
                  value={orgName}
                  onChange={(e) => setOrgName(e.target.value)}
                />
              </Form.Item>

              <Form.Item label="Environment Type" required>
                <Input
                  placeholder="Enter environment type (e.g. DEV, UAT, SIT, QA...)"
                  value={environmentType}
                  onChange={(e) => setEnvironmentType(e.target.value)}
                />
              </Form.Item>

              <div style={{ textAlign: 'right' }}>
                <Space>
                  <Button onClick={handleCancel}>Cancel</Button>
                  <Button
                    type="primary"
                    onClick={handleSave}
                    loading={loading}
                    disabled={!orgName.trim() || !environmentType.trim()}
                  >
                    Save
                  </Button>
                </Space>
              </div>
            </Col>
          </Row>
        </Form>
      )}
    </Modal>
  );
};

export default CloneOrgModal;